import { ModalManagerProvider } from './ModalManagerProvider';
import { Modal } from './Modal';
import { ModalType } from './modalType';
export const ModalManager = {
  Modal,
  Provider: ModalManagerProvider,
  types: ModalType
};